import React from 'react';
import style from './footer2CompoStyle.module.css';
import youtube from '../../assets/images/Icons/icon-sosmed/youtube-icon.svg';
import instagram from '../../assets/images/Icons/icon-sosmed/instagram-icon.svg';
import facebook from '../../assets/images/Icons/icon-sosmed/facebook-icon.svg';
import tiktok from '../../assets/images/Icons/icon-sosmed/tiktok-icon.svg';
import playstore from '../../assets/images/Section-Footer-Button-Download-Playstore-Large.svg';
export const Footer2Component = () => {
  return (
    <>
      <footer id="kontak">
        <div className={`${style.container} container text-center`}>
          <div className={`${style.awal} row awal text-center mb-0`}>
            <div className={`${style['icon-logo']} col icon-logo`}>
              <p>&copy;2022 Copyright Sepakat</p>
              <a
                href="https://www.youtube.com/channel/UChSicdrwHc5api6jWRCICCQ"
                target="_blank" rel='noreferrer'
                className="me-3"
              >
                <img src={youtube} alt="" />
              </a>
              <a
                href="https://www.instagram.com/sepakat.properti"
                target="_blank" rel='noreferrer'
                className="me-3"
              >
                <img src={instagram} alt="" />
              </a>
              <a
                href="https://www.tiktok.com/@sepakat.properti"
                target="_blank" rel='noreferrer'
                className="me-3"
              >
                <img src={tiktok} alt="" />
              </a>
              <a href="https://www.facebook.com/sepakat.properti"
                target="_blank" rel='noreferrer'>
                <img src={facebook} alt="" />
              </a>
                  <a href="https://play.google.com/store/apps/details?id=id.asc.sepakat" className={`${style['anchor-playstore']}`}>
              <img
                src={playstore}
                alt="" width={150}
                className={`${style['logo-playstore']} logo-playstore`}
              />
                  </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
